import React from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";

/**
 * 페이지가 바뀔 때 본문이 부드럽게 나타나도록 감싸는 껍데기.
 *
 * 경로가 바뀔 때마다 key 가 바뀌어 다시 마운트되고, 그때 짧은 페이드가 실행된다.
 * 화면이 즉시 교체되면 깜빡이는 것처럼 보이는데, 240ms 정도의 페이드만 넣어도
 * 전환이 이어져 보인다.
 */
const PageTransition = ({ children }) => {
  const { pathname } = useLocation();

  return (
    <Box
      key={pathname}
      sx={{
        width: "100%",
        minWidth: 0,
        animation: "pageFadeIn 240ms ease-out",
        "@keyframes pageFadeIn": {
          from: { opacity: 0, transform: "translateY(6px)" },
          to: { opacity: 1, transform: "none" },
        },
        // 움직임 최소화를 켜 둔 사용자에게는 애니메이션을 적용하지 않는다.
        "@media (prefers-reduced-motion: reduce)": {
          animation: "none",
        },
      }}
    >
      {children}
    </Box>
  );
};

export default PageTransition;
